<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <h2>Factura</h2>

        <v-menu ref="menuDate" v-model="menuDate" :close-on-content-click="false" :return-value.sync="document.date"
          transition="scale-transition" offset-y min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="document.date" label="Data" prepend-icon="event" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="document.date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menuDate.save(document.date)">OK</v-btn>
          </v-date-picker>
        </v-menu>

        <v-text-field v-if="show" label="Numar factura" placeholder="Completati doar daca se doreste suprascrierea"
          v-model="document.number">
        </v-text-field>

        <h2>Cumparator</h2>

        <v-text-field label="Nr.Reg.Com:" v-model="document.nrRegCom"> </v-text-field>

        <v-text-field label="Contul:" v-model="document.bankIBAN"> </v-text-field>

        <v-text-field label="Banca:" v-model="document.bankName"> </v-text-field>

        <h2>Produse</h2>

        <ProductsGroup :products="document.products" />

        <h2>Date privind expeditia</h2>

        <v-text-field label="Mijlocul de transport nr.:" v-model="document.transportNr">
        </v-text-field>

        <v-textarea label="Notite" v-model="document.notes">
        </v-textarea>

        <h2>Factura se achita cu</h2>

        <v-switch label="POS" v-model="document.isPayedWithPOS" @click="document.isPayedWithReceipt = false" class="mx-2">
        </v-switch>

        <v-switch label="Chitanta" v-model="document.isPayedWithReceipt" @click="document.isPayedWithPOS = false"
          class="mx-2"> </v-switch>

        <div v-if="document.isPayedWithReceipt">
          <v-text-field label="Casier:" v-model="document.cashier" :rules="requiredRules" required>
          </v-text-field>

          <v-text-field label="Numar chitanta" placeholder="Completati doar daca se doreste suprascrierea"
            v-model="document.receiptNumber">
          </v-text-field>

          <v-menu ref="menuReceiptDate" v-model="menuReceiptDate" :close-on-content-click="false"
            :return-value.sync="document.receiptDate" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="document.receiptDate" label="Data" prepend-icon="event" readonly
                v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="document.receiptDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menuReceiptDate = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menuReceiptDate.save(document.receiptDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </div>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary" class="mr-2">Salvare</v-btn>
          <v-btn @click="previewInvoice" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import ProductsGroup from '../ProductsGroup.vue';
import { hasAccess, PERMISSION_LEVEL_ADMIN } from '../../utils/permissions';
import { busEvent } from '../../main';

const transportNr = 'IF02RTS';
const cashier = 'ROBERT STEFANESCU';

export default {
  components: {
    ProductsGroup,
  },
  data() {
    return {
      show: hasAccess(PERMISSION_LEVEL_ADMIN),
      valid: true,
      menuDate: false,
      menuReceiptDate: false,
      document: {
        type: 'invoice',
        date: new Date().toISOString().substr(0, 10),
        nrRegCom: '',
        bankIBAN: '',
        bankName: '',
        transportNr: transportNr,
        products: [],
        isPayedWithPOS: false,
        isPayedWithReceipt: true,
        receiptDate: new Date().toISOString().substr(0, 10),
        receiptNumber: '',
        cashier: cashier,
        invoiceId: this.$route.params.id,
        notes: ''
      },

      requiredRules: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completat.';
          return true;
        },
      ],
      requiredNumberRules: [
        (element) => {
          // eslint-disable-next-line no-restricted-globals
          if (!element || isNaN(Number(element))) return 'Campul trebuie completat';
          return true;
        },
      ],
    };
  },

  async created() {
    // check if we're on edit screen
    if (this.$route.name === 'Editare factura') {
      await this.prefillExistingInvoice();
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        if (this.document.products.length) {
          if (this.$route.name === 'Editare factura') {
            this.$store
              .dispatch('documents/update', {
                clientId: this.$route.params.clientId,
                body: this.document,
              })
              .then(() => {
                busEvent.$emit('succesPopupCreated', 'Factura a fost editata');
                this.$router.back();
              });
          } else {
            this.$store
              .dispatch('documents/create', {
                clientId: this.$route.params.clientId,
                body: this.document,
              })
              .then(() => {
                busEvent.$emit('succesPopupCreated', 'Factura a fost creata');
                this.$router.back();
              });
          }
        } else {
          busEvent.$emit(
            'errorPopupCreated',
            'Factura trebuie sa contina cel putin un produs sau serviciu'
          );
        }
      }
    },

    async prefillExistingInvoice() {
      const invoice = await this.$store.dispatch('documents/getInvoiceById', this.$route.params.id);
      this.document = {
        ...this.document,
        ...invoice,
      };

      this.document.number = invoice.document.number;
      this.document.products = JSON.parse(
        JSON.stringify(
          invoice.items.map((el) => {
            el.isNewProduct = true;
            return el;
          })
        )
      );
      this.document.receiptNumber = invoice.receiptNr;
      this.document.transportNr = transportNr;
      this.document.cashier = cashier;
      this.document.type = 'invoice';
    },

    async previewInvoice() {
      if (this.$refs.form.validate() && this.valid) {
        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName = response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style></style>
